module.exports = __webpack_public_path__ + "img/file-code.30712eb1.svg";